import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const BOND_DISPUTE_SOURCES_A = [
  {
    sourceId: "bond-dispute-source-disputes",
    topicId: "rental-bond-disputes",
    title: "Dealing with bond disputes for tenants",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/residential-rental-bonds/dealing-bond-disputes-for-tenants",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 landlord claim 사유, 7-day evidence, 14-day Notice of Claim, dispute·freeze·NCAT와 payout 후 6-month application 경로를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW residential bond deduction 통지·증거·분쟁 절차",
    followUp: "Notice of Claim의 due date, current RBO action과 NCAT application timing을 즉시 재확인",
  },
  {
    sourceId: "bond-dispute-source-refund",
    topicId: "rental-bond-disputes",
    title: "Getting your bond back at the end of a tenancy",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/getting-your-bond-back",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 rent·cleaning·keys·condition 점검, tenant-first claim, landlord 14-day response와 shared-tenancy claim을 확인",
    reviewStatus: "live_verified",
    claimScope: "tenancy 종료 후 tenant bond refund claim과 일반 준비사항",
    followUp: "bank details, principal tenant, paper·online bond와 current processing status 확인",
  },
  {
    sourceId: "bond-dispute-source-rbo-tenant",
    topicId: "rental-bond-disputes",
    title: "Lodge or manage a residential rental bond (tenants)",
    publisher: "Service NSW",
    url: "https://www.service.nsw.gov.au/referral/lodge-a-residential-rental-bond-tenants",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Service NSW 공식 본문에서 tenant RBO account, bond status·notifications, online refund claim과 offline claim 경로를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW tenant의 RBO bond 관리·refund claim과 paper alternative",
    followUp: "bond number, tenant names, bank details와 online·paper lodgement status 확인",
  },
  {
    sourceId: "bond-dispute-source-landlord-claim",
    topicId: "rental-bond-disputes",
    title: "Lodge a residential bond claim (landlords and agents)",
    publisher: "Service NSW",
    url: "https://www.service.nsw.gov.au/transaction/lodge-a-residential-bond-claim-landlords-and-agents",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Service NSW 공식 본문에서 unpaid rent·water·break fee·damage beyond fair wear·cleaning·keys claim examples와 competing-claim 14-day process를 확인",
    reviewStatus: "live_verified",
    claimScope: "landlord·agent가 residential bond에서 주장할 수 있는 일반 항목과 claim 순서",
    followUp: "각 deduction의 legal basis, actual loss, depreciation·betterment와 supporting evidence 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of BOND_DISPUTE_SOURCES_A) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
